import { ProfileCompletedEffects } from './profile-completed.effect';

export const appEffects = [ProfileCompletedEffects];

export * from './profile-completed.effect';
